/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_002: Question = {
  id: 'pres-002-superficie-aires-protegees',
  oldId: '16',
  title: 'Superficie des aires protégées',
  number: '2.2',
  description: [''],
  frequency: 3,
  type: QuestionType.INDICATOR,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.HECTARE,
    },
  ],
};

const question_pres_002__v3: Question = {
  ...question_pres_002,
  frequency: 2,
};

export const question_pres_002_v2: Question = question_pres_002;
export const question_pres_002_v3: Question = question_pres_002__v3;
